var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 18H5.5C4.949 18 4.5 17.552 4.5 17V7.25L11.9 12.8C12.078 12.934 12.289 13 12.5 13C12.711 13 12.922 12.934 13.1 12.8L20.5 7.25V17C20.5 17.552 20.051 18 19.5 18ZM18.833 6L12.5 10.75L6.167 6H18.833ZM19.5 4H5.5C3.846 4 2.5 5.346 2.5 7V17C2.5 18.654 3.846 20 5.5 20H19.5C21.154 20 22.5 18.654 22.5 17V7C22.5 5.346 21.154 4 19.5 4Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.880b3cfc2c31e379ad39c5a302f90c38.svg";
export { ForwardRef as ReactComponent };